import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
  standalone: false,
  selector: 'app-comparison-ranking-list',
  templateUrl: './comparison-ranking-list.component.html',
  styleUrls: ['./comparison-ranking-list.component.scss'],
})
export class ComparisonRankingListComponent implements OnInit {
  @Input() title = ''
  @Input() showViewFullTable = true
  @Input() data: {
    title: string
    list: { label: string; value: number; unit: ''; numeric: boolean }[]
  }[] = []
  @Input() labelKey = 'name'
  @Input() valueKey = 'nvisits'
  @Input() popupTitle = ''
  @Input() columns: {
    title: string
    key: string
    sortable: boolean
    selected: boolean
  }[] = []
  @Output() onClickViewFullTable = new EventEmitter()

  constructor() {}

  ngOnInit() {}

  openPopup() {
    this.onClickViewFullTable.emit()
  }
}
